import styled from "styled-components";
import { variables } from "../../../styles";

export const Box = styled.div`
  margin-bottom: ${variables.space.base};
`;
